import { Link } from "react-router-dom";

const Section = ({ n, title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-2xl font-semibold tracking-tight">{n}. {title}</h2>
    <div className="text-foreground/80 leading-relaxed mt-2 space-y-2">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid="privacy-page">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-primary">Legal</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tighter mt-2">Privacy Policy</h1>
      <p className="text-muted-foreground mt-2">Last Updated: {new Date().getFullYear()}</p>

      <Section n="1" title="Information We Collect">
        <p>We collect the information you provide when you register (name, email, and optionally your mobile phone number), the services and bookings you create, and payment status from our payment processor (we never store full card details).</p>
      </Section>

      <Section n="2" title="How We Use Your Information">
        <p>We use your information to operate the Services: to authenticate you, process bookings and payments, and send you account and service-related communications, including the text messages described in Section 4.</p>
      </Section>

      <Section n="3" title="How We Share Your Information">
        <p>We may share your information in the following circumstances:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><b>Service Providers:</b> With third-party vendors who perform services on our behalf (e.g., payment processing, hosting, analytics), subject to confidentiality obligations.</li>
          <li><b>Business Transfers:</b> In connection with a merger, acquisition, or sale of assets, subject to standard confidentiality protections.</li>
          <li><b>Legal Requirements:</b> When required to comply with applicable law, regulation, legal process, or governmental request.</li>
          <li><b>Protection of Rights:</b> To protect the rights, property, or safety of BookdHUB, our users, or others.</li>
          <li><b>With Your Consent:</b> In any other circumstances where you have provided explicit consent.</li>
        </ul>
        <p><b>We do not sell your personal information for monetary consideration.</b></p>
      </Section>

      <Section n="4" title="Mobile Information & SMS">
        <p>If you opt in, we use your mobile number to send account and service-related text messages, including booking confirmations and appointment reminders.</p>
        <p><b>We do not sell or share your mobile phone number or SMS opt-in data with third parties or affiliates.</b> Your number is shared only with our SMS provider (Twilio) solely to deliver the messages you have requested or consented to.</p>
        <p>You can opt out of text messages at any time by replying <b>STOP</b>, or reply <b>HELP</b> for assistance. Message and data rates may apply; message frequency varies.</p>
      </Section>

      <Section n="5" title="Data Security">
        <p>We implement reasonable administrative, technical, and physical safeguards designed to protect your information from unauthorized access, use, or disclosure. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>
      </Section>

      <Section n="6" title="Data Retention">
        <p>We retain personal information for as long as necessary to fulfill the purposes described in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>
      </Section>

      <Section n="7" title="Your Rights and Choices">
        <p>Depending on your location, you may have certain rights regarding your personal information, including the right to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Access, correct, or delete your personal information</li>
          <li>Withdraw consent to communications, including text messages (see Section 4)</li>
          <li>Object to or restrict certain processing of your data</li>
          <li>Request a copy of your data in a portable format</li>
        </ul>
        <p>To exercise these rights, please contact us using the information in Section 11.</p>
      </Section>

      <Section n="8" title="Cookies and Tracking Technologies">
        <p>We use cookies and similar tracking technologies to operate and improve our Services, analyze usage, and deliver relevant content. You can control cookies through your browser settings; disabling cookies may affect certain features of the Services.</p>
      </Section>

      <Section n="9" title="Children's Privacy">
        <p>Our Services are not directed to individuals under the age of 13, and we do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.</p>
      </Section>

      <Section n="10" title="Changes to This Privacy Policy">
        <p>We may update this Privacy Policy from time to time. We will post the revised policy on this page with an updated "Last Updated" date. Your continued use of the Services after any changes indicates your acceptance of the updated policy.</p>
      </Section>

      <Section n="11" title="Contact">
        <p>Privacy questions? Email <a href="mailto:privacy@bookdhub.com" className="text-primary underline">privacy@bookdhub.com</a>.</p>
      </Section>

      <p className="mt-10 text-sm"><Link to="/terms" className="text-primary underline">Terms of Service</Link> · <Link to="/register" className="text-primary underline">Back to sign up</Link></p>
    </div>
  );
}
